import {
  WebsocketGatewayService,
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@ipreo/northstar';
import { Injectable, Inject } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import {
  LiveUpdateMessage,
  LiveUpdateMessageBase,
} from '../types/live-update.types';

export const THROTTLE_DELAY = 30000;
export function getMessageDelay<T extends LiveUpdateMessageBase>(
  message: T | T[]
) {
  const msg =
    Array.isArray(message) && message.length > 0
      ? Math.random() > 0.5
        ? message[0]
        : message[message.length - 1]
      : (message as T);

  return msg.Delay * 1000 + msg.RandomizationPeriod * 1000 * Math.random();
}

@Injectable()
export class LiveUpdateService {
  private channelName: string;
  private sub: Observable<LiveUpdateMessage>;
  constructor(
    private webSocketGatewayService: WebsocketGatewayService,
    @Inject(ENVIRONMENT_CONFIG) private environmentConfig: EnvironmentConfig
  ) {
    this.channelName = this.environmentConfig.params
      .dealUpdateChannel as string;
  }

  public startPolling() {
    if (!this.channelName) {
      return EMPTY;
    }

    if (!this.sub) {
      this.sub = this.webSocketGatewayService.subscribe(
        this.channelName
      ) as Observable<LiveUpdateMessage>;
    }

    return this.sub;
  }

  public stopPolling() {
    this.webSocketGatewayService.unsubscribe(this.channelName);
  }
}
